module.exports = __webpack_public_path__ + "media/music/drumkit_8-18bc28cc.mp3";